module.exports = __webpack_public_path__ + "img/shengxian.c43aaea4.png";